/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { ErrorStruct } from '../entities/ErrorStruct'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorCodeSchema } from './errorCodeSchema'
import { errorMessageSchema } from './errorMessageSchema'
import { z } from 'zod'

export const errorStructSchema = z.object({
  error_code: z.lazy(() => errorCodeSchema).optional(),
  error_message: z.lazy(() => errorMessageSchema).optional(),
}) as unknown as ToZod<ErrorStruct>